import {
  UPDATE_SETTINGS_META_DATA,
  UPDATING_SETTINGS_META_DATA,
  UPDATING_SETTINGS_META_DATA_SUCCEEDED,
  UPDATING_SETTINGS_META_DATA_FAILED,
  SAVE_SETTINGS_SUCCEEDED,
  CLEAR_SETTINGS_STORE,
  GETTING_ALL_META_DATA,
  GETTING_ALL_META_DATA_SUCCEEDED,
  GETTING_ALL_META_DATA_FAILED,
  SET_TIME_ZONE_MODIFIED,
  UNSET_TIME_ZONE_MODIFIED,
  UPDATE_LANGUAGE_PREFERENCE,
  UPDATE_TEMPLATE_LANGUAGE_PREFERENCE,
  GET_AVAILABLE_LANGUAGES,
  GET_AVAILABLE_LANGUAGES_SUCCEEDED,
  GET_AVAILABLE_LANGUAGES_FAILED
} from './actions';
import { createReducer } from '@reduxjs/toolkit';

const initialState = {
  settingsMetaData: {
    getting: false,
    updating: false,
    error: {},
    data: null,
    isUpdated: false
  },
  isSettingsUpdated: false,
  isTimeZoneModified: false,
  gettingAvailableLanguages: false,
  availableLanguages: [],
  currentLanguage: {},
  currentTemplateLanguage: {}
};

export default createReducer(initialState, (builder) => {
  builder
    .addCase(UPDATE_SETTINGS_META_DATA, (state, action) => {
      return {
        ...state,
        settingsMetaData: {
          ...state.settingsMetaData,
          updating: true,
          data: action.payload,
          isUpdated: false
        }
      };
    })
    .addCase(UPDATING_SETTINGS_META_DATA, (state) => {
      return {
        ...state,
        isTimeZoneModified: false,
        settingsMetaData: {
          ...state.settingsMetaData,
          updating: true
        }
      };
    })
    .addCase(UPDATING_SETTINGS_META_DATA_SUCCEEDED, (state, action) => {
      return {
        ...state,
        settingsMetaData: {
          getting: false,
          updating: false,
          error: null,
          data: action.payload,
          isUpdated: true
        },
        timeZone: action.payload.timeZone
      };
    })
    .addCase(UPDATING_SETTINGS_META_DATA_FAILED, (state, action) => {
      return {
        ...state,
        settingsMetaData: {
          ...state.settingsMetaData,
          error: action.error,
          isUpdated: false
        }
      };
    })
    .addCase(CLEAR_SETTINGS_STORE, () => {
      return {
        ...initialState
      };
    })
    .addCase(GETTING_ALL_META_DATA, (state) => {
      state.settingsMetaData = {
        getting: true,
        error: {},
        data: null
      };
    })
    .addCase(GETTING_ALL_META_DATA_SUCCEEDED, (state, action) => {
      state.settingsMetaData = {
        getting: false,
        error: {},
        data: action.payload
      };
      state.timeZone = action.payload.timeZone;
    })
    .addCase(GETTING_ALL_META_DATA_FAILED, (state, action) => {
      state.settingsMetaData = {
        getting: true,
        error: {},
        data: null
      };
      return state;
    })
    .addCase(SAVE_SETTINGS_SUCCEEDED, (state) => {
      return {
        ...state,
        isSettingsUpdated: true
      };
    })
    .addCase(SET_TIME_ZONE_MODIFIED, (state) => {
      return {
        ...state,
        isTimeZoneModified: true
      };
    })
    .addCase(UNSET_TIME_ZONE_MODIFIED, (state) => {
      return {
        ...state,
        isTimeZoneModified: false
      };
    })
    .addCase(UPDATE_LANGUAGE_PREFERENCE, (state, action) => {
      return {
        ...state,
        currentLanguage: action.payload
      };
    })
    .addCase(UPDATE_TEMPLATE_LANGUAGE_PREFERENCE, (state, action) => {
      return {
        ...state,
        currentTemplateLanguage: action.payload
      };
    })
    .addCase(GET_AVAILABLE_LANGUAGES, (state) => {
      return {
        ...state,
        gettingAvailableLanguages: true
      };
    })
    .addCase(GET_AVAILABLE_LANGUAGES_SUCCEEDED, (state, action) => {
      return {
        ...state,
        gettingAvailableLanguages: false,
        availableLanguages: action.payload
      };
    })
    .addCase(GET_AVAILABLE_LANGUAGES_FAILED, (state, action) => {
      return {
        ...state,
        gettingAvailableLanguages: false
      };
    });
});
